// extracted by mini-css-extract-plugin
export default {"text":"header_tag_text__JAqyt","homepage_text":"header_tag_homepage_text__YfpWt"};